<template >
  <div class="picking-excel" style="color: #000 !important;">
    <el-dialog
      :title="generateCustomizeString('batchExportPickingInfo')"
      :visible.sync="pickingExcelVisible"
      width="90%"
    >
      <el-button
        type="primary"
        class="button"
        @click="downloadFile()"
      >{{ generateCustomizeString('exportExcel') }}</el-button>
      <el-checkbox
        style="margin-left:20px;"
        v-model="is_included_shipping_data"
      >{{ generateCustomizeString('includeShippingAddress') }}</el-checkbox>
      <el-table :data="showData" tooltip-effect="dark" border>
        <el-table-column
          :label="generateCustomizeString('tradeNo')"
          prop="out_trade_no"
          width="200"
        ></el-table-column>
        <el-table-column :label="generateCustomizeString('numberOfProducts')" prop="quantity"></el-table-column>
        <el-table-column
          :label="generateCustomizeString('goodsName')"
          prop="product_full_name"
          width="500"
        ></el-table-column>
        <el-table-column :label="generateCustomizeString('productSku')" prop="bar_code"></el-table-column>
        <el-table-column
          :label="generateCustomizeString('warehouseName')"
          prop="warehouse_name"
          width="100"
        ></el-table-column>
        <el-table-column :label="generateCustomizeString('unitPrice')" prop="order_price">
          <template slot-scope="scope">
            <span>$ {{scope.row.order_price}}</span>
          </template>
        </el-table-column>
        <template v-if="is_included_shipping_data">
          <el-table-column
            :label="generateCustomizeString('customerId')"
            prop="customer"
            width="100"
          >
            <template slot-scope="scope">
              <span>{{scope.row.customer}}</span>
              <span>{{scope.row.nickname}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="generateCustomizeString('recipientName')" prop="consignee_name"></el-table-column>
          <el-table-column
            :label="generateCustomizeString('identityNumber')"
            prop="person_id"
            width="200"
          ></el-table-column>
          <el-table-column :label="generateCustomizeString('recipientPhone')" prop="phone"></el-table-column>
          <el-table-column
            :label="generateCustomizeString('shippingAddress')"
            prop="address_detail"
            width="400"
          ></el-table-column>
        </template>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import XLSX from 'xlsx'
import XLSX_SAVE from 'file-saver'

export default {
  name: 'PickingExcel',
  data() {
    return {
      pickingExcelVisible: false,
      pickingExcelPopoverVisible: false,
      outFile: '',
      showData: [],
      ids: '',
      pickingExcelData: [],
      includeShipExcelData: [],
      currentdate: '',
      is_included_shipping_data: false
    }
  },
  mounted() {
    this.outFile = document.getElementById('downlink')
  },
  methods: {
    generateCustomizeString,
    handleExcelClick(ids) {
      request({
        url: '/order/picking/' + ids,
        method: 'get'
      })
        .then(response => {
          this.showData = []
          this.pickingExcelData = []
          this.includeShipExcelData = []
          for (var i = 0; i < response.data.length; i++) {
            const item = response.data[i]
            for (var j = 0; j < item.order_goods.length; j++) {
              // UI need
              const goods = item.order_goods[j]
              const showItem = []
              showItem['out_trade_no'] = item.out_trade_no
              showItem['quantity'] = goods.quantity
              showItem['product_full_name'] = goods.product_full_name
              showItem['order_price'] = parseFloat(
                (goods.order_price * 100) / 10000
              ).toFixed(2)
              showItem['warehouse_name'] = goods.warehouse_name
              showItem['bar_code'] = goods.bar_code

              showItem['customer'] = item.customer.phone
              if (
                item.customer.wechat_auths.length > 0 &&
                item.customer.wechat_auths[0].user_info
              ) {
                showItem['nickname'] =
                  item.customer.wechat_auths[0].user_info.nickname
              }

              if (item.order_address) {
                showItem['consignee_name'] = item.order_address.consignee_name
                showItem['person_id'] = item.order_address.person_id
                showItem['phone'] = item.order_address.phone
                showItem['address_detail'] = item.order_address.address_detail
              }
              this.showData.push(showItem)

              // Excel Need
              const noIncludeExcelItem = {
                OrderId: 'No.' + showItem.out_trade_no,
                GoodsQty: showItem.quantity,
                GoodsName: showItem.product_full_name,
                Barcode: showItem.bar_code,
                Warehouse: showItem.warehouse_name,
                OrderPrice: '$' + showItem.order_price
              }
              this.pickingExcelData.push(noIncludeExcelItem)

              const includeExcelItem = {
                OrderId: 'No.' + showItem.out_trade_no,
                GoodsQty: showItem.quantity,
                GoodsName: showItem.product_full_name,
                Barcode: showItem.bar_code,
                Warehouse: showItem.warehouse_name,
                OrderPrice: '$' + showItem.order_price,
                Customer: showItem.customer + ' ' + showItem.nickname,
                Receiver: showItem.consignee_name,
                ReceiverID: 'ID: ' + showItem.person_id,
                ReceiverPhone: 'Tel: ' + showItem.phone,
                ReceiverAddress: showItem.address_detail
              }
              this.includeShipExcelData.push(includeExcelItem)
            }
          }
          this.pickingExcelVisible = true
        })
        .catch(error => {
          console.warn(error)
        })
    },
    getNowFormatDate() {
      var date = new Date()
      var seperator1 = '-'
      var seperator2 = ':'
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      this.currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        ' ' +
        date.getHours() +
        seperator2 +
        date.getMinutes() +
        seperator2 +
        date.getSeconds()
    },
    downloadFile: function() {
      this.getNowFormatDate()
      /* make the worksheet */
      var ws
      if (this.is_included_shipping_data) {
        ws = XLSX.utils.json_to_sheet(this.includeShipExcelData, {
          skipHeader: false
        })
      } else {
        ws = XLSX.utils.json_to_sheet(this.pickingExcelData, {
          skipHeader: false
        })
      }

      /* write workbook (use type 'binary') */
      var csv = XLSX.utils.sheet_to_csv(ws)

      /* prepend UTF-8 BOM */
      const str = '\ufeff' + csv

      /* force a download */
      XLSX_SAVE.saveAs(
        new Blob([str], { type: 'application/octet-stream' }),
        this.currentdate + '.csv'
      )
      this.pickingExcelPopoverVisible = false
      this.pickingExcelVisible = false
    },

    s2ab: function(s) {
      // 字符串转字符流
      var buf = new ArrayBuffer(s.length)
      var view = new Uint8Array(buf)
      for (var i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    },
    getCharCol: function(n) {
      // 将指定的自然数转换为26进制表示。映射关系：[0-25] -> [A-Z]。
      let s = ''
      let m = 0
      while (n > 0) {
        m = (n % 26) + 1
        s = String.fromCharCode(m + 64) + s
        n = (n - m) / 26
      }
      return s
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-table th > .cell {
  text-align: center;
}

.button {
  margin-bottom: 20px;
}
</style>
<style type="text/css">
.picking-excel .el-popover {
  z-index: 1000001 !important;
}
</style>
